// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { PhoneAddStampProcedureArgs_abstract } from './../abstract/SagaBase/PhoneAddStampProcedureArgs_abstract';
export class PhoneAddStampProcedureArgs extends PhoneAddStampProcedureArgs_abstract {}
